import React, { useEffect, useState } from "react";
import { Modal, Skeleton, Spin } from "antd";
import { Survey } from "survey-react-ui";
import { Model } from "survey-core";
import { GetByIdFormulario, SaveFormularioResposta } from "@services/Formulario/Index";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { useDispatch, useSelector } from "react-redux";
import { carregarFormularioRespostaProcesso } from "@store/slices/formularios/Processo/formularioRespostaProcessoSlice";
import { makeSelectFormularioRespostaBySolicitacao } from "@store/selectors/formularios/Processo/formularioRespostaProcessoSelector";
import { customTheme } from "@styles/survey-ui/survey-custom-theme";
import { surveyLocalization } from "survey-core";
import 'survey-core/i18n/portuguese';

surveyLocalization.currentLocale = 'pt';

export const FormularioResponderProcessoModal = ({
  visible,
  onClose,
  idFormularioAssociado,
  idSolicitacao,
  idProcesso,
  formularioRespostaInicial
}) => {
  const dispatch = useDispatch();
  // busca a resposta do formulario associado ao processo e a solicitação
  const respostaRedux = useSelector(makeSelectFormularioRespostaBySolicitacao(idProcesso, idSolicitacao));

  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);

  // initialize redux answer only once
  useEffect(() => {
    if (!respostaRedux && formularioRespostaInicial) {
      dispatch(carregarFormularioRespostaProcesso({ idProcesso, idSolicitacao, resposta: formularioRespostaInicial }));
    }
  }, [respostaRedux, formularioRespostaInicial, dispatch, idProcesso, idSolicitacao]);

  useEffect(() => {
    if (visible) loadForm();
  }, [visible]);

  const loadForm = async () => {
    setLoading(true);
    try {
      const resp = await GetByIdFormulario(idFormularioAssociado);
      const survey = new Model(resp.json);

      survey.completeText = "Salvar Respostas";
      survey.showCompletedPage = true;
      survey.applyTheme({ themeName: "customTheme", cssVariables: customTheme.cssVariables });
      survey.onComplete.add(async sender => {

        const data = sender.data;
        const payload = {
          idFormularioAssociado: idFormularioAssociado,
          idSolicitacao: idSolicitacao,
          formularioJson: JSON.stringify(resp.json),
          respostaJson: JSON.stringify(data)
        };
        try {
          const saved = await SaveFormularioResposta(payload);
          dispatch(carregarFormularioRespostaProcesso({
            idProcesso,
            idSolicitacao,
            resposta: {
              id: saved.id,
              formularioJson: saved.formularioJson,
              respostaJson: saved.respostaJson,
              nomeUsuario: saved.nomeUsuario,
              dataEnvio: saved.dataEnvio
            }
          }));

          SweetAlert.toastSuccess("Resposta salva com sucesso!");
        } catch (e) {
          console.error(e);
          SweetAlert.error("Erro ao salvar resposta.");
        }
      });
      setModel(survey);
    } catch (e) {
      console.error(e);
      SweetAlert.error("Erro ao carregar formulário.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      getContainer={false}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width="60%"
      title="Responder Formulário de Processo"
      destroyOnClose
    >
      <div style={{ minHeight: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {loading ? (
          <div style={{ width: "100%", margin: 10 }}>
            <Skeleton
              active
              paragraph={{ rows: 8, width: ["100%", "80%", "90%", "100%", "60%", "80%", "80%", "90%"] }}
              title={{ width: "40%" }}
              style={{ marginTop: 20 }}
            />
          </div>
        ) : (
          <div style={{ maxHeight: '80vh', overflowY: 'auto', width: "100%", margin: 10 }}>
            {model
              ? <Survey model={model} />
              : <p>Nenhum formulário encontrado.</p>
            }
          </div>
        )}
      </div>
    </Modal>
  );
};